import { browserHistory } from 'react-router'
import React, { Component } from 'react'
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl'
import ImageUploaderDropZone from "../../../../common/image-uploader/dropzone.component.jsx"
import RichTextEditor from "../../../../common/rich-text/editor.component.jsx";
import ColorSelector from "../colorselect.component.jsx";
import SectionContentTypes from "../ContentTypes.jsx";

const messages = defineMessages({
    "templates.sections.form.edit.content.image.size_15_label": {
        id: 'templates.sections.form.edit.content.image.size_15_label',
        defaultMessage: '15%',
    },
    "templates.sections.form.edit.content.image.size_25_label": {
        id: 'templates.sections.form.edit.content.image.size_25_label',
        defaultMessage: "25%",
    },
    "templates.sections.form.edit.content.image.size_50_label": {
        id: 'templates.sections.form.edit.content.image.size_50_label',
        defaultMessage: "50%",
    },
    "templates.sections.form.edit.content.image.size_75_label": {
        id: 'templates.sections.form.edit.content.image.size_75_label',
        defaultMessage: "75%",
    },
    "templates.sections.form.edit.content.image.size_100_label": {
        id: 'templates.sections.form.edit.content.image.size_100_label',
        defaultMessage: "100%",
    },
    "templates.sections.form.edit.content.text_and_image.image_position_left_label": {
        id: 'templates.sections.form.edit.content.text_and_image.image_position_left_label',
        defaultMessage: "Left",
    },
    "templates.sections.form.edit.content.text_and_image.image_position_right_label": {
        id: 'templates.sections.form.edit.content.text_and_image.image_position_right_label',
        defaultMessage: "Right",
    },
    "templates.sections.form.edit.content.text_and_image.vertical_alignment_top_label": {
        id: 'templates.sections.form.edit.content.text_and_image.vertical_alignment_top_label',
        defaultMessage: "Top",
    },
    "templates.sections.form.edit.content.text_and_image.vertical_alignment_middle_label": {
        id: 'templates.sections.form.edit.content.text_and_image.vertical_alignment_middle_label',
        defaultMessage: "Top",
    },
    "templates.sections.form.edit.content.text_and_image.vertical_alignment_bottom_label": {
        id: 'templates.sections.form.edit.content.text_and_image.vertical_alignment_bottom_label',
        defaultMessage: "Top",
    },
})

class TextAndImageContentInput extends Component {

    constructor(props, context) {
        super(props, context)
        const content = this.props.value || {}
        this.state = {
            className: this.props.className || '',
            variables: this.props.variables || {},
            onChange: this.props.onChange || function () { },
            images: content.image ? [content.image] : [],
            image: content.image || null,
            imageId: content.imageId || '',
            alignment: content.alignment || 'middle',
            borderRadius: content.borderRadius || '0',
            imageSize: content.imageSize || '',
            imagePosition: content.imagePosition || 'left',
            backgroundColor: content.backgroundColor || '',
            text: content.text || '',
        }
        this.handleFormChange = this.handleFormChange.bind(this)
        this.handleImageChange = this.handleImageChange.bind(this)
        this.handleTextChange = this.handleTextChange.bind(this)
        this.handleBackgroundColorChange = this.handleBackgroundColorChange.bind(this)
    }

    triggerChanged() {
        this.state.onChange({
            imageId: this.state.imageId,
            alignment: this.state.alignment,
            borderRadius: this.state.borderRadius,
            imagePosition: this.state.imagePosition,
            imageSize: this.state.imageSize,
            text: this.state.text,
            backgroundColor: this.state.backgroundColor,
        })
    }

    componentDidMount() {
        this.triggerChanged()
    }

    componentWillReceiveProps(nextProps) {
        const content = nextProps.value || {}
        this.setState({
            variables: nextProps.variables || {},
            image: content.image || null,
            imageId: content.imageId || '',
            borderRadius: content.borderRadius || '0',
            alignment: content.alignment || 'middle',
            imagePosition: content.imagePosition || 'left',
            imageSize: content.imageSize || '50',
            text: content.text || '',
            backgroundColor: content.backgroundColor || '',
        })
    }

    handleImageChange(images) {
        if (images.length > 0) {
            this.setState({
                images: images,
                image: images[0],
                imageId: images[0].id,
            }, this.triggerChanged)
        } else {
            this.setState({
                images: [],
                image: null,
                imageId: '',
            }, this.triggerChanged)
        }
    }

    handleFormChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        }, this.triggerChanged)
    }

    handleTextChange(value) {
        this.setState({
            text: value
        }, this.triggerChanged)
    }

    handleBackgroundColorChange(value) {
        this.setState({
            backgroundColor: value
        }, this.triggerChanged)
    }

    render() {
        return (
            <div>
                <div className="form-group row">
                    <label className="col-2 col-form-label text-align-right" htmlFor="title">
                        <FormattedMessage
                            id="templates.sections.form.edit.content.text_and_image.image_label"
                            defaultMessage="Image"
                        />
                    </label>
                    <div className="col-10">
                        <ImageUploaderDropZone
                            onUpdateImageList={this.handleImageChange}
                            maxFiles={1}
                            images={this.state.images}
                        />
                        <small className="form-text text-muted">
                            <FormattedMessage
                                id="templates.sections.form.edit.content.text_and_image.image_description"
                                defaultMessage="Side image"
                            />
                        </small>
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-2 col-form-label text-align-right" htmlFor="imageSize">
                        <FormattedMessage
                            id="templates.sections.form.edit.content.text_and_image.size_label"
                            defaultMessage="Image size"
                        />
                    </label>
                    <div className="col-10">
                        <select
                            name="imageSize"
                            value={this.state.imageSize}
                            onChange={this.handleFormChange}
                            id="imageSize"
                            className="form-control"
                        >
                            <option value="15">
                                {this.props.intl.formatMessage(messages["templates.sections.form.edit.content.image.size_15_label"])}
                            </option>
                            <option value="25">
                                {this.props.intl.formatMessage(messages["templates.sections.form.edit.content.image.size_25_label"])}
                            </option>
                            <option value="50">
                                {this.props.intl.formatMessage(messages["templates.sections.form.edit.content.image.size_50_label"])}
                            </option>
                            <option value="75">
                                {this.props.intl.formatMessage(messages["templates.sections.form.edit.content.image.size_75_label"])}
                            </option>
                        </select>
                        <small className="form-text text-muted">
                            <FormattedMessage
                                id="templates.sections.form.edit.content.text_and_image.size_description"
                                defaultMessage="Size of the image (percentage of the document width)"
                            />
                        </small>
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-2 col-form-label text-align-right" htmlFor="borderRadius">
                        <FormattedMessage
                            id="templates.sections.form.edit.content.text_and_image.border_radius_label"
                            defaultMessage="Rounded corner"
                        />
                    </label>
                    <div className="col-10">
                        <div className="input-group">
                            <input
                                name="borderRadius"
                                value={this.state.borderRadius}
                                onChange={this.handleFormChange}
                                id="borderRadius"
                                type="number"
                                className="form-control"
                                min={0}
                                max={50}
                            />
                            <div className="input-group-append">
                                <span className="input-group-text" id="basic-addon2">%</span>
                            </div>
                        </div>

                        <small className="form-text text-muted">
                            <FormattedMessage
                                id="templates.sections.form.edit.content.text_and_image.border_radius_description"
                                defaultMessage="Size of the rounded corner in percentage of the image width"
                            />
                        </small>
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-2 col-form-label text-align-right" htmlFor="imagePosition">
                        <FormattedMessage
                            id="templates.sections.form.edit.content.text_and_image.image_position_label"
                            defaultMessage="Image position"
                        />
                    </label>
                    <div className="col-10">
                        <select
                            name="imagePosition"
                            value={this.state.imagePosition}
                            onChange={this.handleFormChange}
                            id="imagePosition"
                            className="form-control"
                        >
                            <option value="left">
                                {this.props.intl.formatMessage(messages["templates.sections.form.edit.content.text_and_image.image_position_left_label"])}
                            </option>
                            <option value="right">
                                {this.props.intl.formatMessage(messages["templates.sections.form.edit.content.text_and_image.image_position_right_label"])}
                            </option>
                        </select>
                        <small className="form-text text-muted">
                            <FormattedMessage
                                id="templates.sections.form.edit.content.text_and_image.image_position_description"
                                defaultMessage="Position of the image"
                            />
                        </small>
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-2 col-form-label text-align-right" htmlFor="alignment">
                        <FormattedMessage
                            id="templates.sections.form.edit.content.text_and_image.image_vertical_alignment_label"
                            defaultMessage="Vertical alignment"
                        />
                    </label>
                    <div className="col-10">
                        <select
                            name="alignment"
                            value={this.state.alignment}
                            onChange={this.handleFormChange}
                            id="alignment"
                            className="form-control"
                        >
                            <option value="top">
                                {this.props.intl.formatMessage(messages["templates.sections.form.edit.content.text_and_image.vertical_alignment_top_label"])}
                            </option>
                            <option value="middle">
                                {this.props.intl.formatMessage(messages["templates.sections.form.edit.content.text_and_image.vertical_alignment_middle_label"])}
                            </option>
                            <option value="bottom">
                                {this.props.intl.formatMessage(messages["templates.sections.form.edit.content.text_and_image.vertical_alignment_bottom_label"])}
                            </option>

                        </select>
                        <small className="form-text text-muted">
                            <FormattedMessage
                                id="templates.sections.form.edit.content.text_and_image.vertical_alignment_description"
                                defaultMessage="Vertical alignment of the text next to the image"
                            />
                        </small>
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-2 col-form-label text-align-right" htmlFor="text">
                        <FormattedMessage
                            id="templates.sections.form.edit.content.text_and_image.text_label"
                            defaultMessage="Text"
                        />
                    </label>
                    <div className="col-10">
                        <RichTextEditor
                            enableMergeFields={true}
                            name="text"
                            variables={this.props.variables}
                            value={this.state.text}
                            onChange={this.handleTextChange}
                            id="text"
                            className="form-control"
                            colors={SectionContentTypes.getUniquesColorsFromVariables(this.state.variables)}
                        />
                        <small className="form-text text-muted">
                            <FormattedMessage
                                id="templates.sections.form.edit.content.text_and_image.text_description"
                                defaultMessage="Text next to the image"
                            />
                        </small>
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-2 col-form-label text-align-right" htmlFor="backgroundColor">
                        <FormattedMessage
                            id="templates.sections.form.edit.content.text_and_image.background_color_label"
                            defaultMessage="Background Color"
                        />
                    </label>
                    <div className="col-10">
                        <ColorSelector
                            onChange={this.handleBackgroundColorChange}
                            value={this.state.backgroundColor}
                            variables={this.state.variables}
                        />
                        <small className="form-text text-muted">
                            <FormattedMessage
                                id="templates.sections.form.edit.content.text_and_image.background_color_description"
                                defaultMessage="This color is applied on the background of the text and the image"
                            />
                        </small>
                    </div>
                </div>
            </div>
        );
    }
}

export default injectIntl(TextAndImageContentInput)


// WEBPACK FOOTER //
// ./src/template/sections/content/text-and-image/input.component.jsx